import axios from '@utils/axios';

const customer = {
  state: {
    enabled: false,
    status: 'UNKNOWN',
    partner: {
      fullName: '',
      email: ''
    },
    partnerCandidates: [],
    assignedCustomer: 0,
    requestedAt: '',
    acceptedAt: '',
    infoText: null
  },
  mutations: {
    setEnabled(state, val) {
      state.enabled = val;
    },
    setStatus(state, val) {
      state.status = val;
    },
    setPartnerFullName(state, val) {
      state.partner.fullName = val;
    },
    setPartnerEmail(state, val) {
      state.partner.email = val;
    },
    setAssignedCustomer(state, val) {
      state.assignedCustomer = val;
    },
    setPartnerCandidates(state, val) {
      state.partnerCandidates = val;
    },
    setRequestedAt(state, val) {
      state.requestedAt = val;
    },
    setAcceptedAt(state, val) {
      state.acceptedAt = val;
    },
    setInfoText(state, val) {
      state.infoText = val;
    }
  },
  actions: {
    async resetContext(context) {
      context.commit('setEnabled', false);
      context.commit('setStatus', 'UNKNOWN');
      context.commit('setPartnerFullName', '');
      context.commit('setPartnerEmail', '');
      context.commit('setPartnerCandidates', []);
      context.commit('setAssignedCustomer', 0);
      context.commit('setRequestedAt', '');
      context.commit('setAcceptedAt', '');
      context.commit('setInfoText', '');
    },
    async getCustomerRelationship(context, customerId) {
      const response = await axios.get(`/admin/customerrelationships/customer?customerId=${customerId}`)
        .then((r) => {
          const { result } = r.data;
          context.commit('setEnabled', result.enabled);
          context.commit('setStatus', result.status);
          context.commit('setPartnerFullName', result.requestedPartnerName);
          context.commit('setPartnerEmail', result.requestedPartnerEmail);
          context.commit('setPartnerCandidates', result.partnerCandidates);
          context.commit('setAssignedCustomer', result.assignedCustomerId);
          context.commit('setRequestedAt', result.requestedAt);
          context.commit('setAcceptedAt', result.acceptedAt);
          context.commit('setInfoText', result.infoText);
        });
      return response;
    },
    async acceptCustomerRelationship(context, form) {
      const response = await axios.put('admin/customerrelationships/accept', {
        customerId: form.customerId,
        partnerId: context.state.assignedCustomer
      }).then(() => {
        context.dispatch('getCustomerRelationship', form.customerId);
      });
      return response;
    }
  },
  namespaced: true
};

export default customer;
